// Browser-side JSON download — Blob + anchor click pattern. Supported back
// to IE10 per MDN; no polyfill needed on any modern target. Pulls the
// download as a real file save rather than rendering inline.

export function downloadJson(payload, filename) {
  if (typeof document === "undefined" || typeof URL === "undefined") return;
  const json = JSON.stringify(payload, null, 2);
  const blob = new Blob([json], { type: "application/json" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  // revokeObjectURL frees the blob from memory — without it the browser
  // holds it for the page's lifetime.
  URL.revokeObjectURL(url);
}

// File-safe slug. Lowercase, ASCII alphanumerics + underscores only. Collapses
// runs of non-alphanumerics into a single underscore, trims leading/trailing
// underscores. Used to build the export filename from league names that may
// contain spaces, slashes, emoji, etc.
export function slugify(str) {
  if (!str) return "league";
  return String(str)
    .toLowerCase()
    .normalize("NFKD")
    .replace(/[̀-ͯ]/g, "") // strip diacritics
    .replace(/[^a-z0-9]+/g, "_")
    .replace(/^_+|_+$/g, "")
    || "league";
}
